import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { SubGrupoDTO, SubGrupoResponseDTO, SubGrupoCreateDTO } from '../../models/subgrupo.model';

@Injectable({ providedIn: 'root' })
export class SubGrupoService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<SubGrupoResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<SubGrupoResponseDTO>(patch);
  }

  getById<T>(url: string): Observable<SubGrupoDTO> {
    return this.apiService.read<SubGrupoDTO>(url);
  }

  post<T>(url: string, data: SubGrupoCreateDTO): Observable<SubGrupoDTO> {
    return this.apiService.create<SubGrupoDTO>(url, data);
  }

  put<T>(url: string, data: SubGrupoCreateDTO): Observable<SubGrupoDTO> {
    return this.apiService.update<SubGrupoDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
